// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610130635/js/" + chunkId + "." + {"44":"2035a74b","225":"c4d05431","481":"d2c3aca7","486":"f1c145c4","770":"73643ec2"}[chunkId] + ".0.32140283317182694.chunk.js";
};